import React from "react";
import Style from "style-it";


export default function Card(props) {
  const { children, ...rest } = props;
  return (
    <Style>{`
      .c-card{
        color:  ${props.themecolors.textColor};
        width: 100%;
        height: 100%;
        border: 0;
        display: flex;
        position: relative;
        font-size: .875rem;
        min-width: 0;
        word-wrap: break-word;
        background: ${props.themecolors.backgroundColor};
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        border-radius: 6px;
        flex-direction: column;
        overflow: hidden;
        padding: 16px
      }
      .c-card-label {
        font-size: 16px;
        text-align: right;
      }
      .c-card-count {
        margin-top: 0px;
        min-height: 1.5em;
        font-weight: 900;
        margin-bottom: 3px;
        text-decoration: none;
        font-size: 57px;
        text-align: right;
        
      }
      .card-footer svg {
        top: 4px;
        width: 16px;
        height: 16px;
        position: relative;
        margin-left: 3px;
        margin-right: 3px;
      }
      .card-footer {
        margin: 20px 15px 10px;
        display: flex;
        padding: 0;
        align-items: center;
        padding-top: 10px;
        border-radius: 0;
        justify-content: space-between;
        background-color: transparent;
        border-top: 1px solid #eee;
        color: #999;
        font-size: 12px;
        line-height: 22px;
      }
      .c-card-header {
        font-size: 18px;
        padding: 14px;
      }
    `}
    <div className="c-card" {...rest}>
      {children}
    </div>
    </Style>
  );
}

